import styled from 'styled-components'
import variables from 'Styled/variables'

export const StyledPageSubHeader = styled.div`
  font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  line-height: 27px;
  color: ${variables.colorMainText};
  font-weight: ${variables.fontWeight400};
  font-size: ${variables.fontSize18};
`
